<template>
  <div>
    <img :src="$assets.homeHero" style="width: 100%;"/>
  </div>
</template>

<script>
  import LoadingSpinner from '../components/LoadingSpinner.vue'

  export default {
    name: 'TestPage',
    components: { LoadingSpinner },
  }
</script>

<style lang="scss" scoped>
  @media screen and (max-width: 380px) {
    .img-container {
      background-size: 186%;
    }
  }

  @media screen and (min-width: 380px) {
    .img-container {
      background-size: auto;
    }
  }

  * {
    image-rendering: high-quality;
  }

  img {
    width: 100%;
    //transform: translate3d(0,0,0);
  }

</style>
